// extracted by mini-css-extract-plugin
export var text = "_1b-0";